import React, { useEffect, useState } from 'react';
import Barcode from 'react-barcode';
import LogoBB from '../images/bb.png'
import { Flex, Avatar, Divider, QRCode, Card, Image, Skeleton } from 'antd'
import IMGPIX from '../images/pix.png'
import dayjs from 'dayjs';
import IMGLOGORET from '../images/Logo-retangular.png'
import IMGPIXMEDIO from '../images/medium_PIX.jpg'
import api from '../service/axios'
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import { useToasts } from 'react-toast-notifications'
import { userState } from '../service/database'
import { useRecoilState } from 'recoil'


// Estilização baseada nas normas de boletos do BB
const cellStyle = { borderBottom: '1px solid #001a66', borderRight: '1px solid #001a66', padding: '4px', verticalAlign: 'top' };
const labelStyle = { fontSize: '9px', color: '#444', textTransform: 'uppercase', display: 'block', fontWeight: 'bold' };
const valueStyle = { fontSize: '12px', fontWeight: 'bold', display: 'block', minHeight: '16px', color: '#000' };


const BoletoBBCtrl = (props) => {

    const [user,] = useRecoilState(userState)
    const { addToast } = useToasts()
    const [loading, setLoading] = useState(false)
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({
        content: () => contentRef.current,

    });

    const { solicitacaoid } = props
    const [dadosBoleto, setDadosBoleto] = useState({
        beneficiario: {},
        pagador: {}
    })


    useEffect(() => {
      //  console.log("boletoBBCtrl")
        load()
    }, [])


    async function load() {
        try {

            setLoading(true)
            const result1 = await api.get('/api/v1.0/registrado/solicitacao',
                {
                    headers: {
                        'x-access-token': user?.token2
                    },
                    params: { id: solicitacaoid }
                })
           // console.log(result1.data, "result1.data.relacionatipo: ",result1.data.relacionatipo)
            if (result1.data.tipo === "ART") {
                const result = await api.get('/api/v1.0/registrado/art/load',
                    {
                        headers: {
                            'x-access-token': user?.token2
                        },
                        params: { id: result1.data.relacionatipo }
                    })
                setDadosBoleto(result.data.solicitacao.boletos[0])
            }
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading(false)
    }



    const copiarLinha = () => {
        navigator.clipboard.writeText(dadosBoleto.codigoLinhaDigitavel);
        alert('Linha digitável copiada!');
    };


    if (loading)
        return <Flex vertical>
            <Skeleton active />
            <Skeleton active />
        </Flex>


    return <Flex vertical ref={contentRef}>
        <style type="text/css" media="print">
            {" @page { size: portrait; } "}
        </style>
        <div style={{ width: '660px', margin: '20px auto', fontFamily: 'Arial, sans-serif', color: '#000' }}>

            {/* Bloco de Ações (Escondido na Impressão) */}
            <div style={{ marginBottom: '25px', display: 'flex', gap: '12px' }} className="no-print">
                <button onClick={copiarLinha} style={{ padding: '10px 18px', cursor: 'pointer', fontWeight: 'bold', background: '#001a66', color: '#fff', border: 'none', borderRadius: '4px' }}>
                    Copiar Código
                </button>
                <button onClick={handlePrint/*() => window.print()*/} style={{
                    padding: '10px 18px', cursor: 'pointer', fontWeight: 'bold',
                    background: '#ffd700', color: '#001a66', border: 'none', borderRadius: '4px'
                }}>
                    Imprimir Boleto
                </button>
            </div>







            <Card style={{ marginBottom: 10 }} className='apenas-impressao'>
                <Image preview={false} height={90} src={IMGLOGORET} />
            </Card>

            {/* ---------------- FICHA DE COMPENSAÇÃO (Obrigatoriedade Febraban) ---------------- */}
            <div style={{ border: '2px solid #001a66', padding: '0px', background: '#fff' }}>

                {/* Topo do Boleto: Logo + Código do BB + Linha Digitável */}
                <div style={{ display: 'flex', alignItems: 'center', borderBottom: '2px solid #001a66', padding: '5px 10px', background: '#fff' }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '200px' }}>
                        <Avatar shape='square' src={LogoBB} size={35} />
                        <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#001a66' }}>BANCO DO BRASIL</span>
                    </div>
                    <div style={{ fontSize: '20px', fontWeight: 'extrabold', color: '#001a66', width: '75px', borderLeft: '2px solid #001a66', borderRight: '2px solid #001a66', textAlign: 'center', lineHeight: '35px' }}>
                        001-9
                    </div>
                    <div style={{ fontSize: '13px', fontWeight: 'bold', flex: 1, textAlign: 'right', color: '#000', letterSpacing: '0.3px' }}>
                        {dadosBoleto.linhaDigitavel}
                    </div>
                </div>

                {/* Linhas de Dados estruturadas em Tabela Rígida */}
                <table cellPadding="0" cellSpacing="0" style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
                    <tbody>
                        <tr>
                            <td colSpan="4" style={{ ...cellStyle, width: '75%', borderLeft: 'none' }}><span style={labelStyle}>Local de Pagamento</span><span style={valueStyle}>QUALQUER BANCO ATÉ O VENCIMENTO</span></td>
                            <td style={{ ...cellStyle, width: '25%', background: '#f9f9f9', borderRight: 'none' }}><span style={labelStyle}>Vencimento</span><span style={{ ...valueStyle, textAlign: 'right', paddingRight: '5px' }}>{dayjs(dadosBoleto.vencimento).format('DD/MM/YYYY')}</span></td>
                        </tr>
                        <tr>
                            <td colSpan="4" style={{ ...cellStyle, borderLeft: 'none' }}><span style={labelStyle}>Cedente / Beneficiário</span>
                                <span style={valueStyle}>{dadosBoleto.beneficiario?.nome?.toUpperCase()}</span></td>
                            <td style={{ ...cellStyle, borderRight: 'none' }}><span style={labelStyle}>Agência / Código Beneficiário</span>
                                <span style={{ ...valueStyle, textAlign: 'right', paddingRight: '5px' }}>{dadosBoleto.beneficiario.agencia}</span></td>
                        </tr>
                        <tr>
                            <td style={{ ...cellStyle, width: '18%', borderLeft: 'none' }}><span style={labelStyle}>Data do Doc.</span><span style={valueStyle}>{dayjs(dadosBoleto.createAt).format('DD/MM/YYYY')}</span></td>
                            <td style={{ ...cellStyle, width: '22%' }}><span style={labelStyle}>Nº do Documento</span><span style={valueStyle}>{dadosBoleto?.numero?.split('-')[0]}</span></td>
                            <td style={{ ...cellStyle, width: '15%' }}><span style={labelStyle}>Espécie Doc.</span><span style={valueStyle}>DM</span></td>
                            <td style={{ ...cellStyle, width: '20%' }}><span style={labelStyle}>Aceite</span><span style={valueStyle}>N</span></td>
                            <td style={{ ...cellStyle, borderRight: 'none' }}><span style={labelStyle}>Data Processamento</span>
                                <span style={{ ...valueStyle, textAlign: 'right', paddingRight: '5px' }}>{dayjs(dadosBoleto.createAt).format('DD/MM/YYYY')}</span></td>
                        </tr>
                        <tr>
                            <td colSpan="2" style={{ ...cellStyle, borderLeft: 'none' }}><span style={labelStyle}>Uso do Banco</span><span style={valueStyle}></span></td>
                            <td style={cellStyle}><span style={labelStyle}>Carteira</span><span style={valueStyle}>{dadosBoleto.beneficiario?.carteira}</span></td>
                            <td style={cellStyle}><span style={labelStyle}>Espécie Moeda</span><span style={valueStyle}>R$</span></td>
                            <td style={{ ...cellStyle, borderRight: 'none', background: '#f9f9f9' }}><span style={labelStyle}>Valor do Documento</span>
                                <span style={{ ...valueStyle, textAlign: 'right', paddingRight: '5px' }}>R$ {dadosBoleto.valor?.toFixed(2)}</span></td>
                        </tr>
                        <tr>
                            <td colSpan="4" rowSpan="3" style={{ ...cellStyle, borderLeft: 'none', borderBottom: 'none', fontSize: '11px', padding: '8px', lineHeight: '1.4' }}>
                                <span style={labelStyle}>Instruções (Todas as instruções de pagamento são de responsabilidade do beneficiário)</span>
                                <div style={{ marginTop: '5px', fontWeight: '500' }}>
                                    <Flex vertical>
                                        {dadosBoleto.msgs?.map((item, index) => {
                                            return <Flex key={item}>{item}</Flex>
                                        })
                                        }
                                    </Flex>
                                </div>
                            </td>
                            <td style={{ ...cellStyle, borderRight: 'none' }}><span style={labelStyle}>(-) Desconto / Abatimento</span><span style={valueStyle}></span></td>
                        </tr>
                        <tr>
                            <td style={{ ...cellStyle, borderRight: 'none' }}><span style={labelStyle}>(+) Mora / Multa / Juros</span><span style={valueStyle}></span></td>
                        </tr>
                        <tr>
                            <td style={{ ...cellStyle, borderRight: 'none', borderBottom: 'none', background: '#f9f9f9' }}><span style={labelStyle}>(=) Valor Cobrado</span><span style={valueStyle}></span></td>
                        </tr>
                        <tr>
                            <td colSpan="5" style={{ ...cellStyle, borderLeft: 'none', borderRight: 'none', borderTop: '2px solid #001a66', padding: '8px' }}>
                                <span style={labelStyle}>Pagador / Sacado</span>
                                <span style={{ ...valueStyle, fontSize: '12px' }}>{dadosBoleto.pagador.nome} - {dadosBoleto.pagador.cpfCnpj}</span>
                                <span style={{ fontSize: '11px', color: '#555', display: 'block', marginTop: '2px' }}>{dadosBoleto.pagador.logradouro} - {dadosBoleto.pagador.bairro}
                                    &nbsp;&nbsp;  CEP:{dadosBoleto.pagador.cep} </span>
                                <span style={{ fontSize: '11px', color: '#555', display: 'block', marginTop: '2px' }}>{dadosBoleto.pagador.cidade} /  {dadosBoleto.pagador.uf}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Região do Código de Barras */}
            <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingLeft: '5px' }}>
                <Barcode
                    value={dadosBoleto.codigoBarraNumerico}
                    format="ITF"
                    width={1.25}
                    height={55}
                    displayValue={false}
                    margin={0}
                />
                <span style={{ fontSize: '9px', color: '#666', marginTop: '4px' }}>Ficha de Compensação - Autenticação Mecânica</span>
            </div>


            <Card style={{ marginTop: 10 }}>
                <Flex justify='space-between'>
                    <Flex align='center' gap={10}>
                        <Image preview={false} src={IMGPIXMEDIO} height={120} />
                        <Flex vertical>
                            <Flex align='center' gap={10}>

                                <Flex style={{ fontWeight: 600 }}>PAGAMENTO VIA PIX</Flex>
                            </Flex>

                            <Flex vertical style={{ fontSize: '0.85em', fontStyle: 'italic' }}>
                                {dadosBoleto.msgs?.map((item, index) => {
                                    return <Flex key={item}>{item}</Flex>
                                })
                                }
                                <Flex >Valor do Documento: R${dadosBoleto.valor?.toFixed(2)}</Flex>
                            </Flex>

                        </Flex>
                    </Flex>

                    <Flex>
                        <QRCode errorLevel='M' value={dadosBoleto.qrcode?.emv} size={100} bordered={false} />
                    </Flex>
                </Flex>
            </Card>

            {/* CSS Embutido para gerenciamento de mídia de impressão */}
            <style>{`
                            @media print {
                            .no-print { display: none !important; }
                            body { background: #fff; margin: 0; padding: 0; }
                            table { page-break-inside: avoid; }
                            }
                        `}</style>


        </div>



    </Flex>

}

export default BoletoBBCtrl